module.exports = __webpack_public_path__ + "static/media/cases_3d_04c.1883c962.jpg";